<div class="container has-nav">
  <div class="separator">
    <span></span>
  </div>
  <section
    class="w-6 column m-auto"
    [class.w-8]="deviceService.isTablet()"
    [class.w-12]="deviceService.isMobile()"
  >
    <h1>{{ h1 }}</h1>
    <p>{{ description }}</p>
  </section>
</div>
<div
  class="articles row container m-auto"
  appLazyLoad
  (load)="getArticles()"
  [(loading)]="loading"
  [end]="endLazyLoading"
>
  @if (!deviceService.isMobile()) {
    <div class="article-container">
      <app-article-card *ngFor="let article of articles" [article]="article" class="w-6 article">
      </app-article-card>
      <app-article-card-loading class="article" *ngIf="loading"></app-article-card-loading>
    </div>
  }
  @if (deviceService.isMobile()) {
    <div class="column w-12">
      <app-article-card
        *ngFor="let article of articles"
        [article]="article"
        class="w-12 column-article"
      >
      </app-article-card>
      <app-article-card-loading
        class="full-width"
        *ngIf="loading"
        class="column-article"
      ></app-article-card-loading>
    </div>
  }
  <div #detector></div>
</div>
